import { LegalScreen, LegalSection } from '../components/Legal.jsx';
import { t as tr } from '../lib/i18n.js';
export function PrivacyPolicyView({t,st,dispatch,go}){
  return(
    <LegalScreen t={t} title={tr("priv_title")} icon="🔒" go={go}>
      <div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:18}}>{tr("priv_last_updated")}</div>
      <div style={{background:"#FFF8E8",border:"1px solid #F0DFA0",borderRadius:12,padding:"12px 14px",marginBottom:20,fontSize:11.5,color:"#7A5C00",lineHeight:1.6,fontFamily:"Inter,sans-serif"}}>
        {tr("priv_beta_notice")}
      </div>
      <LegalSection t={t} title={tr("priv_s1_title")}>
        {tr("priv_s1_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s2_title")}>
        {tr("priv_s2_pre")}<b>{tr("priv_s2_bold")}</b>{tr("priv_s2_post")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s3_title")}>
        {tr("priv_s3_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s4_title")}>
        {tr("priv_s4_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s5_title")}>
        {tr("priv_s5_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s6_title")}>
        {tr("priv_s6_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s7_title")}>
        {tr("priv_s7_pre")}<b>{tr("priv_s7_bold1")}</b>{tr("priv_s7_mid")}<b>{tr("priv_s7_bold2")}</b>{tr("priv_s7_post")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s8_title")}>
        {tr("priv_s8_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s9_title")}>
        {tr("priv_s9_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s10_title")}>
        {tr("priv_s10_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s11_title")}>
        {tr("priv_s11_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("priv_s12_title")}>
        {tr("priv_s12_body")}
      </LegalSection>
    </LegalScreen>
  );
}
export function TermsView({t,st,dispatch,go}){
  return(
    <LegalScreen t={t} title={tr("terms_title")} icon="📄" go={go}>
      <div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:18}}>{tr("terms_last_updated")}</div>
      <div style={{background:"#FFF8E8",border:"1px solid #F0DFA0",borderRadius:12,padding:"12px 14px",marginBottom:20,fontSize:11.5,color:"#7A5C00",lineHeight:1.6,fontFamily:"Inter,sans-serif"}}>
        {tr("terms_beta_notice")}
      </div>
      <LegalSection t={t} title={tr("terms_s1_title")}>
        {tr("terms_s1_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s2_title")}>
        {tr("terms_s2_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s3_title")}>
        {tr("terms_s3_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s4_title")}>
        {tr("terms_s4_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s5_title")}>
        {tr("terms_s5_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s6_title")}>
        {tr("terms_s6_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s7_title")}>
        {tr("terms_s7_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s8_title")}>
        {tr("terms_s8_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s9_title")}>
        {tr("terms_s9_body")}
      </LegalSection>
      <LegalSection t={t} title={tr("terms_s10_title")}>
        {tr("terms_s10_body")}
      </LegalSection>
    </LegalScreen>
  );
}
